import { BaseEntity, Entity as DecribeEntity, Relation } from '@avangard/utils/entity';

import { FileInfoEntity } from '@modules/shared/entities';
import type { EgLessonsInstructor } from '@modules/types/graphql';

export type Entity = Partial<EgLessonsInstructor> | null;

@DecribeEntity('LessonsInstructorEntity')
class LessonsInstructorEntity extends BaseEntity {
    id: string;
    name: string;

    @Relation(() => FileInfoEntity)
    photo: FileInfoEntity;

    constructor(entity: Entity) {
        super(entity);

        this.id = entity?.id ?? '';
        this.name = entity?.name ?? '';
    }
}

export { LessonsInstructorEntity };
